/* eslint-disable no-unused-expressions */
import { isEmpty } from 'lodash';
import { put, takeLatest } from 'redux-saga/effects';

import { setInStorage } from '../Common/utils';
import { evvToken } from '../Common/constants';

import { SAVE_SESSION_TOKEN } from './actionTypes';
import { setIsLoggedIn } from './actions';

function* saveSessionToken({ sessionToken = '' } = {}) {
  yield setInStorage(evvToken, sessionToken);
  isEmpty(sessionToken)
    ? yield put(setIsLoggedIn({ isLoggedIn: false }))
    : yield put(setIsLoggedIn({ isLoggedIn: true }));
}

function* saveSessionTokenWatcher() {
  yield takeLatest(SAVE_SESSION_TOKEN, saveSessionToken);
}

export { saveSessionTokenWatcher, saveSessionToken };
